/** Keep the original exception and frame on the page-error telemetry path. */
export function reportDeliveryThrow(error: unknown): void {
    window.dispatchEvent(new ErrorEvent('error', { error, message: String(error) }));
}

/** Plain text; callers escape it with the existing warning UI's HTML helper.
 * A throw can follow a successful save, so another click must not blindly replay it. */
export function abilityDeliveryFailureMessage(error: unknown): string {
    const reason = error instanceof Error ? `${error.name}: ${error.message}` : typeof error === 'string' && error.trim() ? error : 'Unknown error';
    return `Ability delivery stopped: ${reason}. Check the activity log before using it again.`;
}
